import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import PsContext from "../../context";
import { groupByMultiple } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import OnlinyPayRequest from "./onlinyPayRequest";

const OnlinePay = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [response, setReponse] = useState([]);

  const [dataToPay, setDataToPay] = useState([]);

  const [dataGroup, setDataGroup] = useState([]);
  const [notAllow, setNotAllow] = useState([]);

  useEffect(() => {
    let dt = props.dataSource.filter((item) => item.allow_online_pay == "1");
    let nt = props.dataSource.filter((item) => item.allow_online_pay == "0");

    let m = groupByMultiple(dt, function (obj) {
      return [obj.payment_gateway_id];
    });

    setDataGroup(m);
    setNotAllow(nt);
  }, [props.dataSource]);

  const getTotal = () => {
    try {
      let total = 0;
      dataToPay.map(
        (item) => (total = parseFloat(total) + parseFloat(item.fee_amount))
      );
      return parseFloat(total).toFixed(2);
    } catch (er) {
      return 0;
    }
  };

  const handleCancelClick = () => {
    if (props.onCancel) props.onCancel();
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);

      alert("Please accept terms and conditions & check the amount filled");

      return;
    }

    if (dataToPay.length < 1) {
      alert("Please select one category to pay");
      return;
    }
    if (parseFloat(getTotal()) < 1) {
      alert("Please enter valid amount");
      return;
    }

    context.setLoader(true);
    axios.post(ServiceUrl.STUDENTS.PAY_FEES, new FormData(form)).then((res) => {
      if (res["data"].status == "1") {
        setReponse(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
        context.setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (response && response.access_code)
      document.getElementById("redirect").submit();
  }, [response]);

  const getPaymentData = () => {
    try {
      let s = [];
      props.dataSource.map((item, i) => {
        s.push({
          student_uuid: item.student_uuid,
          college_year: item.college_year,
          fee_amount: item.fee_amount,
          original_amount: item.original_amount,
          fee_category_id: item.fee_category_id,
          id: item.id,
          payment_gateway_subid: item.payment_gateway_subid,
          allow_part_payment: item.allow_part_payment,
        });
      });
      return s;
    } catch (er) {
      return [];
    }
  };

  const checkBoxChange = (item, e) => {
    let s = [...dataToPay];
    if (s.length > 0 && s[0].payment_gateway_id != item.payment_gateway_id) {
      alert("Select same bill group to pay");
      return;
    }
    let exist = s.findIndex((obj) => obj.id == item.id);
    if (exist > -1) s.splice(exist, 1);
    else
      s.push({
        student_uuid: item.student_uuid,
        cashbook_id: item.cashbook_id,
        semester: item.semester,
        college_year: item.college_year,
        fee_amount: item.fee_amount,
        original_amount: item.fee_amount,
        fee_category_id: item.fee_category_id,
        id: item.id,
        payment_gateway_id: item.payment_gateway_id,
        payment_gateway_subid: item.payment_gateway_subid,
        allow_part_payment: item.allow_part_payment,
      });

    setDataToPay(s);
  };

  const checkExist = (item) => {
    let exist = dataToPay.findIndex((obj) => obj.id == item.id);
    return exist > -1 ? true : false;
  };

  const amountChange = (item, index, e) => {
    let s = [...dataToPay];
    let exist = s.findIndex((obj) => obj.id == item.id);

    if (exist > -1) {
      s[exist].fee_amount = e.target.value;
      setDataToPay(s);
    }
  };

  const getCategoryAmount = (item) => {
    let s = dataToPay.find((obj) => obj.id == item.id);
    return s.fee_amount;
  };

  return (
    <>
      {/*dataGroup.length > 1 && <></>}
      {dataGroup.length < 2 && (
        <>
          <OnlinyPayRequest
            dataSource={dataGroup[0]}
            onCancel={props.onCancel}
          />
        </>
      )*/}
      {dataGroup.length > 1 ? (
        <>
          <Tabs defaultActiveKey="1">
            {dataGroup.map((item, i) => {
              return (
                <Tabs.TabPane tab={item[0].cashbook_name} key={`tab_${i}`}>
                  <OnlinyPayRequest
                    dataSource={item}
                    notAllowed={notAllow}
                    onCancel={props.onCancel}
                  />
                </Tabs.TabPane>
              );
            })}
          </Tabs>
        </>
      ) : (
        dataGroup.length > 0 && (
          <OnlinyPayRequest
            dataSource={dataGroup[0]}
            notAllowed={notAllow}
            onCancel={props.onCancel}
          />
        )
      )}
    </>
  );
};
export default OnlinePay;
